import { styled } from "@mui/material";

export const ButtonContainer = styled("div")(() => ({
    display: "flex",
    justifyContent: "end",
    gap: "16px",
    marginTop: "16px",
    "@media (max-width: 600px)": {
        position: "sticky",
        bottom: 0,
        backgroundColor: "#FFFFFF",
        padding: "16px 20px",
        marginTop: "0",
        marginLeft: "-20px",
        marginRight: "-20px",
        marginBottom: "-20px",
        zIndex: 10,
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
        paddingBottom: "calc(16px + env(safe-area-inset-bottom, 0px))",
    },
}))

export const CancelButton = styled("div")(() => ({
    display: "flex",
    alignItems: "center",
    color: "#495057",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "500",
    fontFamily: "DM Sans, sans-serif",
}))